import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FlashMessagesService} from "angular2-flash-messages";
import {HttpService} from "../../_service/http.service";
import {PasswordService} from "../../password.service";
import {WelcomeMainComponent} from "../welcome-part.component";

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css']
})
export class RestorePasswordComponent implements OnInit {
  receivedCodeCorrect: boolean = false;
  model: any = {
    numberPrefix: '+7'
  };
  passwordErrorMessage: string = "";

  constructor(private router: Router, private httpService: HttpService,
              private passwordService: PasswordService,
              private flashMessagesService: FlashMessagesService,
              private route: ActivatedRoute,
              public welcomeMainComponent: WelcomeMainComponent,) {
  }

  ngOnInit() {
  }

  async handleCodeCheck(event) {
    console.log("handleCodeCheck in restorePassword comp. event result: ", event);
    if (event.isCodeCorrect) {
      console.log("in event correct!");
      this.model.phone = event.phone;
      this.receivedCodeCorrect = true;
    }
  }

  handlePassword(event) {
    console.log("Handle password event is: ", event);
    this.model.newPassword = event;
  }

  isPasswordCorrect() {
    this.passwordErrorMessage = this.passwordService.checkPassword(this.model.newPassword);
    return this.passwordErrorMessage == "";
  }

  async saveNewPassword() {

    console.log("SAve new password model is : ", this.model);
    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/changePassword');

    const result = {
      phone: this.model.numberPrefix + this.model.phone,
      newPassword: this.model.newPassword
    };

    await this.httpService.postData(sb.join(''), JSON.stringify(result))
      .then(data => {
        console.log("Save new passwrod post response ", data);
        // this.flashMessagesService.show("Теперь вы можете использовать новый пароль!",
        //   {cssClass: 'popup-message flashfade alert-success grow', timeout: 5000});
        this.welcomeMainComponent.onMainMessage = "Теперь вы можете использовать новый пароль! Авторизируйтесь в форме ниже.";
        this.router.navigate(["../login"], {relativeTo: this.route});
      }, (error) => {
        console.log("saveNewPassword error: ", error);
        this.welcomeMainComponent.errorMessage = JSON.parse(error._body).errorTitle;

        this.router.navigate(["../login"], {relativeTo: this.route});
      });

    return true;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/restore-password/restore-password.component.ts